<template>
  <v-layout>
    <v-flex xs12>
      <v-container grid-list-md fluid style="padding: 0;">
        <v-layout row wrap>
          <draggable
                  v-model="sortedWords"
                  :disabled="disabled"
                  class="layout row wrap"
                  @change = "changePosition"
          >
            <v-flex
                    v-for="word in sortedWords"
                    :key="word.id"
                    xs6
                    sm4
                    md3
                    lg2
                    v-on:click="$emit('change', word)"
                    class="item"
            >
              <v-card>
                <v-img
                        :src="word.imageSet.x1 | ifEmpty(require('../assets/No_Image_Available.jpg'))"
                        height="150px"
                        @contextmenu="$emit('menu', $event, word)"
                ></v-img>
                <v-card-title primary-title>
                  <h3 class="headline mb-0">{{ word.text }}</h3>
                </v-card-title>
              </v-card>
            </v-flex>
          </draggable>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import draggable from 'vuedraggable'
import { REORDER_WORDS } from '../store/mutation-types'
import { MOVE_WORD } from '../store/action-types'
import mobileBrowser from 'detect-mobile-browser'

const IS_MOBILE = mobileBrowser(false).isAny()

export default {
  props: ['words'],
  components: {
    draggable
  },
  computed: {
    sortedWords: {
      get () {
        return this.words
      },
      set (words) {
        this.$store.commit(REORDER_WORDS, words)
      }
    },
    disabled () {
      if (IS_MOBILE) {
        return true
      }
      return this.$store.getters.isLoading
    }
  },
  methods: {
    async changePosition ({ moved }) {
      const { element, newIndex, oldIndex } = moved
      let position
      if (newIndex > oldIndex) {
        position = this.words[newIndex - 1].position
      } else {
        position = this.words[newIndex + 1].position
      }

      await this.$store.dispatch(MOVE_WORD, { word: element, position })
    }
  }
}
</script>

<style scoped>
  .item {
    cursor: pointer;
  }
  .item:hover {
    opacity: .7;
  }
</style>
